import React, { useEffect, useState } from 'react';
import UpdateIcon from '@material-ui/icons/Update';
import { Alert } from '@material-ui/lab';
import env from 'common/env';
import { CircularProgress } from '@material-ui/core';

const severity = {
    present: 'warning',
    bill: 'success',
    place: 'info'
};

const LatestActivity = ({ marketDayId, trigger }) => {
    const [loading, setLoading] = useState(false);
    const [raisonSociale, setRaisonSociale] = useState('');
    const [type, setType] = useState(null);
    const [numero, setNumero] = useState(null);

    const fetchActivity = async () => {
        setLoading(true);

        try {
            const response = await fetch(`${env}/placier/get-latest-activity/${marketDayId}`);
            const data = await response.json();

            if (data.numero) {
                setNumero(data.numero);
            }

            if (data.info) {
                setType(data.info);
                setRaisonSociale(data.raisonSociale);
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    const label = () => {
        if (type === 'present') {
            return ' est arrivé(e) sur le marché';
        }

        if (type === 'bill') {
            return ' a été encaissé(e)';
        }

        if (type === 'place') {
            return ` a été placé sur la place ${numero}`;
        }
    };

    useEffect(() => {
        trigger && fetchActivity();
    }, [trigger]);

    if (type === null) {
        return null;
    }

    return (
        <Alert
            style={{ paddingTop: 2, paddingBottom: 2 }}
            severity={severity[type]}
            icon={loading ? <CircularProgress size={24} /> : <UpdateIcon />}
            color={severity[type]}>
            Dernier évènement : {raisonSociale} {label()}
        </Alert>
    );
};

export default LatestActivity;
